/**
 * Google Translate 自訂翻譯切換
 *
 * 隱藏 Google 原生 UI，透過操作 .goog-te-combo 即時切換語言
 * - 桌面版：#gtDropdown（headerTop 內）
 * - 手機版：#gtTool（asideUserTools 內）
 */

window.googleTranslateElementInit = function() {
    new google.translate.TranslateElement({
        pageLanguage: 'zh-TW',
        includedLanguages: 'zh-TW,zh-CN,en,ja,yue,vi'
    }, 'google_translate_element');
};

$(function() {
    var PAGE_LANG = 'zh-TW';
    var gtTimer = null; // 防止多個 setInterval 疊加

    // 從 googtrans cookie 讀取當前語言
    function gtGetCookieLang() {
        var m = document.cookie.match(/googtrans=\/[^/]*\/([^;]*)/);
        return (m && m[1]) ? m[1] : PAGE_LANG;
    }

    // 清除 googtrans cookie（還原用）
    function gtClearCookie() {
        var host = location.hostname;
        var exp = ';expires=Thu, 01 Jan 1970 00:00:00 UTC';
        document.cookie = 'googtrans=' + exp + ';path=/';
        document.cookie = 'googtrans=' + exp + ';path=/;domain=.' + host;
    }

    // 切換語言（含 timer 防重複）
    function gtSetLang(lang) {
        if (gtTimer) {
            clearInterval(gtTimer);
            gtTimer = null;
        }
        var attempt = 0;
        gtTimer = setInterval(function() {
            var sel = document.querySelector('.goog-te-combo');
            if (sel) {
                clearInterval(gtTimer);
                gtTimer = null;
                if (lang === PAGE_LANG) {
                    gtClearCookie();
                }
                sel.value = lang;
                sel.dispatchEvent(new Event('change', { bubbles: true }));
            }
            if (++attempt > 50) {
                clearInterval(gtTimer);
                gtTimer = null;
            }
        }, 300);
    }

    // 更新 UI 狀態（桌面版 + 手機版同步）
    function gtUpdateUI(lang) {
        $('#gtDropdown .gt-list li, #gtTool .gt-list li').each(function() {
            var $li = $(this);
            if ($li.data('lang') === lang) {
                $li.addClass('active').find('.ck').html('<i class="fas fa-check"></i>');
            } else {
                $li.removeClass('active').find('.ck').html('');
            }
        });
    }

    // 頁面載入時，根據 cookie 同步 UI 狀態
    gtUpdateUI(gtGetCookieLang());

    // 桌面版
    $(document).on('click', '#gtBtn', function(e) {
        e.stopPropagation();
        $('#gtDropdown').toggleClass('open');
    });

    $(document).on('click', '#gtDropdown .gt-list li', function(e) {
        e.stopPropagation();
        var lang = $(this).data('lang');
        gtSetLang(lang);
        gtUpdateUI(lang);
        $('#gtDropdown').removeClass('open');
    });

    // 手機版
    $(document).on('click', '#gtTool', function(e) {
        e.stopPropagation();
        $(this).toggleClass('open');
    });

    $(document).on('click', '#gtTool .gt-list li', function(e) {
        e.stopPropagation();
        var lang = $(this).data('lang');
        gtSetLang(lang);
        gtUpdateUI(lang);
        $('#gtTool').removeClass('open');
    });

    // 點擊外部關閉
    $(document).on('click', function() {
        $('#gtDropdown').removeClass('open');
        $('#gtTool').removeClass('open');
    });
});
